import { render, staticRenderFns } from "./ManpowerTypeForm.vue?vue&type=template&id=6ecb32c5&"
import script from "./ManpowerTypeForm.vue?vue&type=script&lang=js&"
export * from "./ManpowerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports